import { shouldPromptConnectAfterAdding } from '~/components/ManagePaymentMethods/ManagePaymentMethods.utils';
export const clientPaymentMethodsTextsPath = 'client.detail.summary.paymentMethods';
export function skipConnectToastText(param) {
    let { hasNoAgreementsToConnect, createdPaymentMethod, texts } = param;
    if (hasNoAgreementsToConnect) return texts.addSuccess();
    if (createdPaymentMethod && !shouldPromptConnectAfterAdding(createdPaymentMethod)) {
        return texts.addedPendingVerification();
    }
    return null;
}
export function connectFailureText(error, texts) {
    const agreements = error.failedAgreementNames.join(', ');
    return error.rejectedAsUnverified ? texts.connectRejectedUnverified({
        agreements
    }) : texts.connectPartialFailure({
        agreements
    });
}
